export default __webpack_public_path__ + "static/media/330_dummy2016-zahnarzt01-de.3549db6b.png";